module.exports = __webpack_public_path__ + "static/media/credit-cards-zelle.fbd6a757.png";